import { Button, Modal } from "antd";

const AddToArchiveModal = ({
  orgId,
  modalOpen,
  onModalClose,
  selectedRowName,
  onConfirm,
  isArchiving
}) => {
  const onClose = () => {
    onModalClose();
  };

  return (
    <Modal
      title={[<div className={"text-2xl"}>Add to Archive</div>]}
      centered
      open={modalOpen}
      footer={[
        <div className={"flex items-center justify-end gap-3"}>
          <Button
            key="cancel"
            className={"px-2 text-sm py-1.5 border border-gray-200 rounded-lg"}
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button
            key="submit"
            className={"px-2 text-sm py-1.5 bg-blue-600 text-white rounded-lg"}
            onClick={onConfirm}
            disabled={isArchiving}
          >
            Add to Archive
          </Button>
        </div>,
      ]}
      onCancel={onClose}
    >
      <div className={"py-8 text-sm border-b border-gray-300 w-full"}>
        <p className="text-sm text-gray-500 "> Your backups are on a 7-day rolling cycle. Archiving a backup means
          we'll make a copy and move it to your archive - which sticks around
          as long as your subscription is active
        </p>
        <br />
        <p className="text-sm text-gray-500 ">You'll still be able to restore from both your active backups and your archive anytime. </p>
        <br />
        <p className="text-lg font-medium mb-4"> Wanna go ahead and archive this backup? </p>
      </div>
    </Modal>
  );
};

export default AddToArchiveModal;
